import DocumentsTab from './DocumentsTab';

export default DocumentsTab;
